import { ESTADOS_INFORME } from '../api/informesEvento'
import { sx } from '../design/tokens'

/** Estado del informe de evento: abierto → cerrado → completo. */
export default function EstadoBadgeInforme({ estado }) {
  const e = ESTADOS_INFORME[estado] || { label: estado, bg: undefined, color: undefined }
  return <span style={{ ...sx.badge, background: e.bg, color: e.color }}>{e.label}</span>
}
